module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/bakery@3x_f2ceee.jpg";